import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Axios from 'axios';
import applyCaseMiddleware from 'axios-case-converter';
import { caseOptions } from "../../helpers/model-converter";
import { Requestor } from "../requestor";
import { TransformerManager } from "../requestor/transformer-utils";
export var BaseApi = function BaseApi() {
  var _config$caseOptions;

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, BaseApi);

  this.requestor = void 0;
  this.auth = void 0;
  var axiosIntance = applyCaseMiddleware(Axios.create(_objectSpread({}, config.request)), (_config$caseOptions = config.caseOptions) !== null && _config$caseOptions !== void 0 ? _config$caseOptions : caseOptions);
  this.auth = _objectSpread({
    alwaysAuth: false,
    getter: null
  }, config.auth);

  if (config.transform) {
    var instanceDefault = axiosIntance.defaults;

    if (config.transform.request) {
      instanceDefault.transformRequest = config.transform.request(new TransformerManager(instanceDefault.transformRequest, ['case-converter', 'default']));
    }

    if (config.transform.response) {
      instanceDefault.transformResponse = config.transform.response(new TransformerManager(instanceDefault.transformResponse, ['default', 'case-converter']));
    }
  }

  if (config.interceptor) {
    var _config$interceptor$r, _config$interceptor$r2;

    var normalize = function normalize(itemOrArrayItems) {
      if (Array.isArray(itemOrArrayItems)) return itemOrArrayItems;
      return [itemOrArrayItems, undefined];
    };

    (_config$interceptor$r = config.interceptor.request) === null || _config$interceptor$r === void 0 ? void 0 : _config$interceptor$r.forEach(function (x) {
      var _axiosIntance$interce;

      return (_axiosIntance$interce = axiosIntance.interceptors.request).use.apply(_axiosIntance$interce, _toConsumableArray(normalize(x)));
    });
    (_config$interceptor$r2 = config.interceptor.response) === null || _config$interceptor$r2 === void 0 ? void 0 : _config$interceptor$r2.forEach(function (x) {
      var _axiosIntance$interce2;

      return (_axiosIntance$interce2 = axiosIntance.interceptors.response).use.apply(_axiosIntance$interce2, _toConsumableArray(normalize(x)));
    });
  }

  this.requestor = new Requestor(axiosIntance);
};